<template>
  <div class="wrap-nav-about">
    <div class="box-nav">
      <b-container>
        <nav>
          <b-row align-h="center">
            <b-col
              v-for="(menu, i) in menus"
              :key="i"
              cols="6"
              md="3"
              lg="auto"
              class="link"
              :class="[ menu.isActive ? 'active' : '' ]"
              @click.prevent="selectContent(i)"
            >
              <div>
                <img :src="require(`../../assets/icons/${menu.icon}`)">
                <span>{{ menu.title }}</span>
              </div>
            </b-col>
          </b-row>
        </nav>
      </b-container>
    </div>

    <b-container>
      <AdmanHistory v-if="menus[0].isActive"/>
      <CommitteeMembers v-if="menus[1].isActive"/>
      <ChairmanBiography v-if="menus[2].isActive"/>
      <MessageFromChairman v-if="menus[3].isActive"/>
    </b-container>
  </div>
</template>

<script>
const AdmanHistory = () => import('./AdmanHistory')
const CommitteeMembers = () => import('./CommitteeMembers')
const ChairmanBiography = () => import('./ChairmanBiography')
const MessageFromChairman = () => import('./MessageFromChairman')

export default {
  components: {
    AdmanHistory,
    CommitteeMembers,
    ChairmanBiography,
    MessageFromChairman
  },

  data () {
    return {
      menus: [
        {
          title: 'Adman History',
          icon: 'icon-chat.png',
          isActive: true
        },
        {
          title: 'Committee Members',
          icon: 'icon-element-about.png',
          isActive: false
        },
        {
          title: 'Chairman Biography',
          icon: 'icon-users-chat.png',
          isActive: false
        },
        {
          title: 'Message From Chairman',
          icon: 'icon-light-left.png',
          isActive: false
        }
      ]
    }
  },

  methods: {
    selectContent (index) {
      this.menus.forEach((menu, i) => {
        this.menus[i].isActive = false
      })

      this.menus[index].isActive = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.wrap-nav-about {
  .box-nav {
    background-color: $light;

    .container {
      nav {
        .row {
          .link {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 62px;
            cursor: pointer;

            div {
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                height: 22px;
              }

              span {
                margin-left: 8px;
                font-size: 1.25rem;
                line-height: 0.8;

                @media only screen and (min-width: $break-l) {
                  font-size: 1.5rem;
                }
              }
            }
          }

          .active {
            border-bottom: 3px solid $active;

            div {
              padding-top: 3px;
            }
          }
        }
      }
    }
  }
}
</style>
